import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    makeStyles,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: ".8rem",
    },
    th: {
        fontWeight: "600",
    },
}));

const Paragraph = ({ children }) => {
    const styles = useStyles();
    return (
        <Typography component="p" className={styles.root}>
            {children}
        </Typography>
    );
};

const Header = ({ children }) => {
    const styles = useStyles();
    return (
        <Typography variant="h4" className={styles.root}>
            {children}
        </Typography>
    );
};

const CookieContent = () => {
    const styles = useStyles();
    return (
        <Typography component="span" variant="body1" color="textSecondary">
            <Typography variant="caption" component="p">
                Last Revised: April 2020
            </Typography>

            <Paragraph>
                This Cookie Notice describes the different types of cookies and similar technologies...
            </Paragraph>

            <Header>1. What is a cookie?</Header>
            <Paragraph>
                Cookies are small text files that a website transfers...
            </Paragraph>
            <ul>
                <li>First party and third party cookies</li>
                <li>Session and permanent cookies</li>
            </ul>

            <Header>2. What cookies do we use?</Header>
            <Paragraph>
                Below we list the different types of cookies...
            </Paragraph>

            <Table className={styles.root}>
                <TableHead>
                    <TableRow>
                        <TableCell className={styles.th}>Cookie Name</TableCell>
                        <TableCell className={styles.th}>Purpose</TableCell>
                        <TableCell className={styles.th}>Duration</TableCell>
                        <TableCell className={styles.th}>Party</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>incap_ses_874_1246096</TableCell>
                        <TableCell>Ensures website security</TableCell>
                        <TableCell>Session</TableCell>
                        <TableCell>3rd party - Imperva</TableCell>
                    </TableRow>
                    {/* Add others similarly... */}
                </TableBody>
            </Table>

            <Paragraph><b>No functional cookies are being used.</b></Paragraph>
            <Paragraph><b>No advertising cookies are being used.</b></Paragraph>

            <Header>3. How do I manage cookies?</Header>
            <Paragraph>
                You can change settings via your browser...
            </Paragraph>

            <Header>4. Local Storage</Header>
            <Paragraph>
                Local Storage is used for storing web data...
            </Paragraph>

            <Table className={styles.root}>
                <TableHead>
                    <TableRow>
                        <TableCell className={styles.th}>Variable Name</TableCell>
                        <TableCell className={styles.th}>Purpose</TableCell>
                        <TableCell className={styles.th}>Persistence</TableCell>
                        <TableCell className={styles.th}>Party</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>wtw.se.fo.jwt</TableCell>
                        <TableCell>Stores generated token</TableCell>
                        <TableCell>Session</TableCell>
                        <TableCell>1st party</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Header>5. Changes</Header>
            <Paragraph>We may update this notice...</Paragraph>

            <Header>6. Contact</Header>
            <Paragraph>
                Email: privacy@willistowerswatson.com <br />
                Address: 51 Lime St, London...
            </Paragraph>
        </Typography>
    );
};

const NoticeDialog = ({ onExit }) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onExited={onExit}
            aria-labelledby="cookie-dialog-title"
            aria-describedby="cookie-dialog-description"
            maxWidth="md"
        >
            <DialogTitle id="cookie-dialog-title">Cookie Notice</DialogTitle>
            <DialogContent>
                <CookieContent />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NoticeDialog;
